import styled, { createGlobalStyle } from "styled-components";
import { Drawer } from "antd";

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-wrapper-body {
    background: var(--topup-recharge-input);
  }
  .ant-drawer-content {
    background: var(--topup-recharge-input);
    color: rgba(255, 255, 255, 0.65);
  }
  .ant-drawer-header {
    border-bottom: 1px solid var(--antd-drawer-header-border);
    background: var(--antd-drawer-header);
  }
  .ant-drawer-header-title {
    flex-direction: row-reverse;
  }
  .ant-drawer-header {
    padding-bottom: 10px;
    padding: 16px 0 16px 24px;
  }
  .ant-drawer-title,
  .ant-drawer-close {
    font-size: 14px !important;
    color: rgba(255, 255, 255, 0.85) !important;
  }
  .ant-drawer-body {
    padding: 0 !important;
    background: var(--topup-recharge-input);
  }

  .border-title .ant-drawer-header {
    border-bottom: 1px solid #43454d !important;
    .ant-drawer-title {
      color: #edf2f5;
      font-size: 14px;
    }
  }
  .ant-drawer-footer {
    background: var(--topup-recharge-input);
  }
`;
